// vue components
import { Carousel } from "@fancyapps/ui";
import ContentSlider from "./vue/components/_content-slider.vue";

Vue.component('content-slider', ContentSlider);
Vue.prototype.Carousel = Carousel;

document.addEventListener("DOMContentLoaded", () => {
    const fancyboxCarousels = document.querySelectorAll('.f-carousel.non-vue');
    if (fancyboxCarousels) {
        fancyboxCarousels.forEach(function (element) {
            const options = {
                infinite: true,
                slidesPerPage: 3,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                breakpoints: {
                    "(min-width: 768px)": {
                        slidesPerPage: 2,
                    },
                    "(min-width: 1200px)": {
                        slidesPerPage: 3,
                    },
                    "(min-width: 2000px)": {
                        slidesPerPage: 4,
                    },
                    "(min-width: 2600px)": {
                        slidesPerPage: 5,
                    }
                }
            };
            const carousel = new Carousel(element, options);
        });
    }
});